import React from 'react';
import { Outlet } from 'react-router-dom';

export const MenuPageLayout: React.FC = () => {
  return (
    <>
      <Outlet />
    </>
  );
};
